
import axios from 'axios'
import Cookies from 'js-cookie'

/**
 * Authentication library for projects developed in
 * Marciano Digital Agency
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
export default class MSAuth {
  /**
   * @param {string} authURL - The authentication API URL
   * @param {string, object} successRoute - The route to be redirected on authentication success
   * @param {string, object} errorRoute - The route to be redirected on authentication success
   */
  constructor (authURL, successRoute, logoutRoute = '/', errorRoute = '/') {
    this.__authURL__ = authURL
    this.__successRoute__ = successRoute
    this.__errorRoute__ = errorRoute
    this.__logoutRoute__ = logoutRoute
  }

  set redirectURL (route) {
    if (typeof route === 'object') {
      this.__redirectRoute__ = route
    } else {
      throw new Error('The route must be a route object')
    }
  }

  get logoutRoute () {
    return this.__logoutRoute__
  }
  /**
   * Authentication method
   * @param username
   * @param password
   * @param rememberMe
   * @returns {Promise<AxiosResponse<any>>}
   */
  authenticate (username, password, rememberMe) {
    this.logout()
    return axios.post(this.__authURL__, {
      username: username,
      password: password,
      rememberMe: rememberMe
    }).then((response) => {
      let authTokenOptions = {}
      let refreshTokenOptions = {}

      if (response.data.rememberMe) {
        // If expires is not set, the cookie will be saved as a session cookie.
        authTokenOptions.expires = new Date(new Date().getTime() + response.data.tokenLife)
        refreshTokenOptions.expires = new Date(new Date().getTime() + response.data.refreshTokenLife)
      }

      Cookies.set('token', response.data.token, authTokenOptions)
      Cookies.set('auth-refresh-token', response.data.refreshToken, refreshTokenOptions)
      return response
    }).catch((error) => {
      this.logout()
      throw error
    })
  }

  /**
   * Return the URL or Route
   * to be redirected on success.
   */
  get redirectURL () {
    return this.__redirectRoute__ || this.__successRoute__
  }

  /**
   * Removes the session cookies
   * from the client
   */
  logout () {
    Cookies.remove('token')
    Cookies.remove('auth-refresh-token')
  }

  /**
   * Returns if the user is authenticated
   * or not
   * @returns {boolean}
   */
  isAuthenticated () {
    return !!Cookies.get('token')
  }

  /**
   * Returns the current authorization token
   * @returns {string} authorization token
   */
  token () {
    return Cookies.get('token')
  }
}



// WEBPACK FOOTER //
// ./src/utilis/ms-auth.js